module.exports = "/_next/static/images/handalt-e64e9bcf434a4017ef5beed949e609ea.svg";